import './work.css';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import React, { useState, useEffect } from 'react';

export const Work = () => {
  const [yearsInBusiness, setYearsInBusiness] = useState(0);

  useEffect(() => {
    const currentYear = new Date().getFullYear();  // 現在の年を取得
    const foundingYear = 1923;  // 創業年を指定
    const years = currentYear - foundingYear;  // 創業年から現在までの年数を計算
    setYearsInBusiness(years);  // 状態を更新
  }, []);

  return (
    <>
      <Header />
      <main>
        <div className='contents-title-box'>
          <h3>制作体制・実績</h3>
        </div>
        <div className='result-item-box'>
          <div className='result-item'>
            <h4>会社データ</h4>
            <p>創業 : <span className='f-color-base' >{yearsInBusiness}</span>年</p>
            <p>社員数 : <span className='f-color-base' >20</span>名(パート含む)</p>
          </div>
          <div className='result-item'>
            <h4>国内生産データ</h4>
            <p>専属職人 : <span className='f-color-base' >25</span>人</p>
            <p>月間生産数 : 約<span className='f-color-base'>8,500</span>個</p>
          </div>
          <div className='result-item'>
            <h4>海外生産データ</h4>
            <p>協力工場 : <span className='f-color-base'>2</span>社</p>
            <p>月間生産数 : 約<span className='f-color-base'>50,000</span>個</p>
          </div>
        </div>
        <div className='contents-title-box'>
          <h3>製品ができるまで</h3>
        </div>
        <div className = 'workflow-item-box'>
          <div className='workflow-item'>
            <div className='workflow-item-title f-color-base'>
              <p>STEP<span>1</span></p>
              <h4>ご依頼</h4>
            </div>
            <p>
              画面右下の「<img src='img/help.png' height='24px' />」からお気軽にお問い合わせください。生産する物、展開時期、ロット数などをお伝えいただけるとスムーズです。 もちろん、未定の部分があってもかまいません。相談しながら決めていきましょう。
            </p>
          </div>
          <img src='img/workflow_1_img.jpg' />
        </div>
        <div className = 'workflow-item-box'>
          <div className='workflow-item'>
            <div className='workflow-item-title f-color-base'>
              <p>STEP<span>2</span></p>
              <h4>お打ち合わせ</h4>
            </div>
            <p>
              お聞かせいただいたお話を元に、そのイメージを具体化していきます。デザインの提案、製造上のアドバイスなども行うことができますので、お気軽にお申し付けください。
            </p>
          </div>
          <img src='img/workflow_2_img.jpg' />
        </div>
        <div className = 'workflow-item-box'>
          <div className='workflow-item'>
            <div className='workflow-item-title f-color-base'>
              <p>STEP<span>3</span></p>
              <h4>サンプル作成</h4>
            </div>
            <p>
              打ち合わせですり合わせたイメージを元に、弊社サンプル室にて丁寧にサンプル品を製作します。 必要に応じて、複数素材出し、複数デザイン出しも可能です。 細かい修正・調整にも対応します。お客様にご納得いただけるまで、とことん対応させていただきます。
            </p>
          </div>
          <img src='img/workflow_3_img.jpg' />
        </div>
        <div className = 'workflow-item-box'>
          <div className='workflow-item'>
            <div className='workflow-item-title f-color-base'>
              <p>STEP<span>4</span></p>
              <h4>生産</h4>
            </div>
            <p>
              完成したサンプル品を基に国内または海外で量産します。
            </p>
          </div>
          <img src='img/workflow_4_img.jpg' />
        </div>
        <div className = 'workflow-item-box'>
          <div className='workflow-item'>
            <div className='workflow-item-title f-color-base'>
              <p>STEP<span>5</span></p>
              <h4>検品・仕上げ</h4>
            </div>
            <p>
              国内・海外生産製品ともに、弊社専門スタッフが検品を行います。 
            </p>
          </div>
          <img src='img/workflow_5_img.jpg' />
        </div>
      </main>
      <Footer />
    </>
  );
};
